var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyGradation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 7.21484,
    r: 5.5,
    fill: "url(#paint0_linear_1537_2777)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67871 15.9626C3.67871 14.6533 4.74017 13.5918 6.04954 13.5918H18.4507C19.7601 13.5918 20.8216 14.6533 20.8216 15.9626C20.8216 19.4543 17.991 22.2848 14.4994 22.2848H10.0009C6.50926 22.2848 3.67871 19.4543 3.67871 15.9626Z",
    fill: "url(#paint1_linear_1537_2777)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1537_2777",
    x1: 6.75,
    y1: 5.20409,
    x2: 17.9798,
    y2: 11.4754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1537_2777",
    x1: 3.67871,
    y1: 16.3493,
    x2: 14.0541,
    y2: 27.7756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525DE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyGradation);
export default __webpack_public_path__ + "static/media/myGradation.8fff32a6439f58e15ddcf15f00890ed2.svg";
export { ForwardRef as ReactComponent };